import { render, staticRenderFns } from "./BackgroundCatalogue.vue?vue&type=template&id=057ae8cf&scoped=true&"
import script from "./BackgroundCatalogue.vue?vue&type=script&lang=js&"
export * from "./BackgroundCatalogue.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundCatalogue.vue?vue&type=style&index=0&id=057ae8cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057ae8cf",
  null
  
)

export default component.exports